import React, { useState } from "react"
import { Modal } from "components/Core"
import { HiPlus, HiOutlineSearch } from "react-icons/hi"

interface StoresListModalProps {
  isOpen: boolean
  onClose: () => void
  stores: any[]
}

const StoresListModal = ({ isOpen, onClose, stores }: StoresListModalProps) => {
  const [searchTerm, setSearchTerm] = useState("")

  const filteredStores = stores.filter(store => 
    String(store.id).toLowerCase().includes(searchTerm.toLowerCase()) ||
    String(store.name).toLowerCase().includes(searchTerm.toLowerCase())
  )

  return (
    <Modal mounted={isOpen} className="!w-[420px] shadow-2xl rounded-3xl overflow-hidden">
      <div className="flex flex-col bg-white">
        <div className="p-5 border-b border-gray-100 flex flex-row justify-between items-center bg-gray-50/50">
          <div className="flex flex-col">
            <h3 className="text-[15px] font-bold text-gray-800">Tiendas Asociadas</h3>
            <p className="text-[12px] font-medium text-gray-400">Listado de puntos de venta</p>
          </div>
          <button onClick={onClose} className="p-1.5 hover:bg-gray-200/50 rounded-full transition-colors text-gray-400">
            <HiPlus className="text-xl transform rotate-45" />
          </button>
        </div>

        {/* Search Bar */}
        <div className="px-5 py-3 border-b border-gray-50">
          <div className="relative group">
            <HiOutlineSearch className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400 group-focus-within:text-indigo-500 transition-colors" />
            <input 
              type="text"
              placeholder="Buscar por ID o nombre..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="w-full bg-gray-100/50 border border-transparent focus:border-indigo-100 focus:bg-white focus:ring-4 focus:ring-indigo-50/50 rounded-xl py-2 pl-10 pr-4 text-[13px] font-medium text-gray-600 transition-all outline-none"
            />
          </div>
        </div>

        <div className="p-2 h-[320px] md:h-[450px] overflow-y-auto">
          {filteredStores.length > 0 ? (
            filteredStores.map((store: any, idx: number) => (
              <div
                key={idx}
                className="flex flex-row items-center gap-4 p-3 hover:bg-gray-50 rounded-xl transition-colors group"
              >
                <div className="w-10 h-10 flex items-center justify-center bg-indigo-50 text-indigo-500 rounded-full font-bold text-[13px] group-hover:bg-indigo-100 transition-colors">
                  {store.id}
                </div>
                <div className="flex flex-col">
                  <span className="text-[14px] font-semibold text-gray-700">{store.name}</span>
                  <span className="text-[11px] font-medium text-gray-400 uppercase tracking-wider">
                    Código: {store.custom?.codVTASA || "N/A"}
                  </span>
                </div>
              </div>
            ))
          ) : (
            <div className="flex flex-col items-center justify-center py-10 gap-2 opacity-40">
              <HiOutlineSearch className="text-3xl" />
              <p className="text-[13px] font-medium italic">No se encontraron tiendas</p>
            </div>
          )}
        </div>
      </div>
    </Modal>
  )
}

export default StoresListModal
